import { useStore, Store } from '@/store';
import { GeneralActionTypes } from '@/store/modules/general/action-types';
import { getConfig } from './config';

export default class SessionTimeoutTimer {
  timer = 0;
  store: Store;
  timeout: number;

  constructor() {
    this.store = useStore();
    this.timeout = getConfig('displayModalTimeout');
    this.addEventListeners();
    this.start();
  }

  start() {
    this.timer = setTimeout(() => {
      this.store.dispatch(GeneralActionTypes.SET_SHOW_SESSION_MODAL, true);
      this.stop();
    }, this.timeout);
  }

  restart() {
    clearTimeout(this.timer);
    this.start();
  }

  stop() {
    clearTimeout(this.timer);
    this.timer = 0;
  }

  addEventListeners() {
    const events = ['mousemove', 'click', 'keydown', 'wheel'];

    const restartTimer = () => {
      if (this.timer) {
        this.restart();
      }
    };

    for (const event of events) {
      window.addEventListener(event, restartTimer);
    }
  }
}
